import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as ThemeActions from '../actions/theme.actions';

import { ThemeState } from '@store/entities';
import { Theme } from '../../admin/models';

export const themeAdapter: EntityAdapter<Theme> = createEntityAdapter<Theme>({
  selectId: theme => theme.idTheme,
});

export const initialState: ThemeState = themeAdapter.getInitialState({
  selectedThemeId: null,
  isLoading: false,
  error: null,
});

export const themeReducer = createReducer<ThemeState>(
  initialState,
  on(ThemeActions.getTheme, (state, { idTheme }) => ({
    ...state,
    selectedThemeId: idTheme,
    isLoading: true,
  })),
  on(ThemeActions.getThemeSuccess, (state, { theme }) => {
    return themeAdapter.addOne(theme, { ...state, isLoading: false });
  }),
  on(ThemeActions.getThemeFailure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  })),
  on(ThemeActions.clearTheme, () => initialState)
);
